<script setup lang="ts">
import { onMounted, watch } from 'vue';
import useModal, { modals } from '../../../composables/useModal';
import Modal from '../../Modal.vue';
import ImportUsersContent from './ImportUsersContent.vue';
import { useGetOrganization } from '@ilteducation/customer-mgmt';
import { useLocale } from '../../../composables/useLocale';
import { ref } from 'vue';

type Props = {
  name: 'IMPORT_USERS';
  organizationUid: string;
};
const props = defineProps<Props>();
const { isOpen, close } = useModal(modals.IMPORT_USERS);
const { t } = useLocale();

const { organization, loadOrganization, isLoading: isOrgLoading } = useGetOrganization();

onMounted(() => {
  if (props.organizationUid) {
    loadOrganization(props.organizationUid);
  }
});

watch(
  () => props.organizationUid,
  () => {
    if (props.organizationUid) {
      loadOrganization(props.organizationUid);
    }
  },
);

const isLoading = ref<boolean>(false);
const confirmAndClose = () => {
  close();
};

const onImportStatusChange = (val: boolean) => {
  isLoading.value = val;
};
</script>

<template>
  <Modal
    :name="name"
    :is-open="isOpen"
    fullscreen
    contained
    :loading="isLoading || isOrgLoading"
    :show-close-btn="false"
    :show-cancel-action="false"
    :top-left-btn-action="confirmAndClose"
    :top-left-btn-label="t('lcp.close')"
    top-left-btn-icon="mdi-close"
    :disableAutoClose="true"
  >
    <ImportUsersContent v-if="organization" :organization="organization" :onImportStatusChange="onImportStatusChange" />
  </Modal>
</template>
